import { z } from 'zod';

export const paginationSchema = z.object({
    page: z.number(),
    pageSize: z.number(),
    totalCount: z.number(),
    itemCount: z.number(),
    totalPages: z.number(),
    items: z.array(z.any()),
});